document.addEventListener('DOMContentLoaded', () => {
  const panel = document.getElementById('HawthornWelcome');
  if (!panel) return;
  const form = document.getElementById('HawthornWelcomeForm');
  const result = document.getElementById('HawthornWelcomeResult');
  const error = document.getElementById('HawthornWelcomeError');
  const submit = form?.querySelector('[type="submit"]');
  const offerButtons = document.querySelectorAll('[data-hh-offer-open]');
  let activeTrigger = null;
  const challengeBox = document.getElementById('HawthornWelcomeChallenge');
  const challengeStatus = document.createElement('p');
  challengeStatus.className = 'hh-welcome__fine';
  challengeStatus.setAttribute('role', 'status');
  challengeStatus.setAttribute('aria-live', 'polite');
  challengeBox?.after(challengeStatus);
  const retryChallenge = document.createElement('button');
  retryChallenge.type = 'button';
  retryChallenge.className = 'hh-welcome__security-retry';
  retryChallenge.textContent = 'Retry security check';
  retryChallenge.hidden = true;
  challengeStatus.after(retryChallenge);
  let widgetId = null;
  let challengeLoading = false;
  let challengeReady = false;
  let busy = false;
  let challengeTimer;
  const updateChallenge = (message, ready = false, retry = false) => {
    if (ready || retry) window.clearTimeout(challengeTimer);
    challengeReady = ready;
    challengeStatus.textContent = message;
    retryChallenge.hidden = !retry;
    submit.disabled = busy || !ready;
  };
  const challengeFailed = () => updateChallenge(
    'The security check could not finish. Retry below, or open this page in your usual browser with blockers paused for this site.', false, true
  );
  const renderChallenge = () => {
    if (!challengeBox || !window.turnstile || widgetId !== null) return;
    try {
      widgetId = window.turnstile.render(challengeBox, {
        sitekey: challengeBox.dataset.sitekey,
        size: 'flexible', theme: 'light',
        callback: () => { error.hidden = true; updateChallenge('Security check complete.', true); },
        'error-callback': () => { challengeFailed(); return true; },
        'expired-callback': () => updateChallenge('Security check expired. Please retry.', false, true),
        'timeout-callback': () => updateChallenge('Security check timed out. Please retry.', false, true)
      });
    } catch { challengeFailed(); }
  };
  const loadChallenge = () => {
    if (widgetId !== null || challengeLoading) return;
    updateChallenge('Preparing the security check…');
    window.clearTimeout(challengeTimer);
    challengeTimer = window.setTimeout(challengeFailed, 20000);
    if (window.turnstile) { renderChallenge(); return; }
    challengeLoading = true;
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = () => { challengeLoading = false; renderChallenge(); };
    script.onerror = () => { challengeLoading = false; script.remove(); challengeFailed(); };
    document.head.appendChild(script);
  };
  retryChallenge.addEventListener('click', () => {
    error.hidden = true;
    updateChallenge('Preparing the security check…');
    window.clearTimeout(challengeTimer);
    challengeTimer = window.setTimeout(challengeFailed, 20000);
    if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
    else loadChallenge();
  });
  updateChallenge('Preparing the security check…');
  const setOpen = (open, trigger) => {
    if (open) activeTrigger = trigger || null;
    panel.hidden = !open;
    offerButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (open) { panel.focus(); loadChallenge(); }
    if (!open && activeTrigger) activeTrigger.focus();
  };
  offerButtons.forEach((button) => button.addEventListener('click', () => setOpen(true, button)));
  if (sessionStorage.getItem('hawthornWelcomeDismissed') !== '1') {
    // Let the shopper look first: after the cookie choice, wait 15s and a scroll of most of a screen, or 30s.
    let scrolled = false;
    let clearSince = null;
    const onScroll = () => { if (window.scrollY > window.innerHeight * 0.75) scrolled = true; };
    window.addEventListener('scroll', onScroll, { passive: true });
    const reveal = () => {
      if (sessionStorage.getItem('hawthornWelcomeDismissed') === '1' || !panel.hidden) return;
      const cookieBanner = document.getElementById('shopify-pc__banner');
      if (cookieBanner && getComputedStyle(cookieBanner).display !== 'none') {
        clearSince = null;
        window.setTimeout(reveal, 1000);
        return;
      }
      onScroll();
      if (clearSince === null) clearSince = Date.now();
      const waited = Date.now() - clearSince;
      if ((scrolled && waited >= 15000) || waited >= 30000) {
        window.removeEventListener('scroll', onScroll);
        setOpen(true);
        return;
      }
      window.setTimeout(reveal, 1000);
    };
    window.setTimeout(reveal, 6500);
  }
  panel.querySelector('[data-hh-welcome-close]')?.addEventListener('click', () => {
    setOpen(false);
    sessionStorage.setItem('hawthornWelcomeDismissed', '1');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      sessionStorage.setItem('hawthornWelcomeDismissed', '1');
    }
  });
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submit.disabled) return;
    error.hidden = true;
    const data = new FormData(form);
    const endpoint = form.dataset.hhWelcomeEndpoint;
    const challenge = data.get('cf-turnstile-response');
    if (!endpoint || endpoint === 'SET_AT_DEPLOYMENT' || !challenge) {
      error.textContent = 'Please complete the security check and try again.';
      error.hidden = false;
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Preparing your code…';
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: data.get('email'), consent: data.get('consent') === 'on',
          website: data.get('website'), challenge
        })
      });
      const payload = await response.json();
      if (!response.ok || payload.status !== 'issued' || !/^HH10-[A-F0-9]{16}$/.test(payload.code || '')) {
        throw new Error(payload.error || (payload.status === 'not_eligible' ? 'This offer is for first orders only.' : 'Please try again shortly.'));
      }
      window.HawthornRecovery?.identify(data.get('email'), data.get('consent') === 'on');
      document.getElementById('HawthornWelcomeCode').textContent = payload.code;
      document.getElementById('HawthornWelcomeDeliveryNote').textContent =
        'Use it at checkout on an eligible first order. A copy is on its way by email.';
      form.hidden = true;
      result.hidden = false;
      sessionStorage.setItem('hawthornWelcomeDismissed', '1');
    } catch (problem) {
      error.textContent = problem.message || 'Please try again shortly.';
      error.hidden = false;
      updateChallenge('Preparing a fresh security check…');
      if (widgetId !== null) window.turnstile?.reset(widgetId);
    } finally {
      submit.disabled = false;
      submit.textContent = 'Get my code';
    }
  });
  panel.querySelector('[data-hh-welcome-copy]')?.addEventListener('click', async (event) => {
    const code = document.getElementById('HawthornWelcomeCode').textContent;
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(code);
      button.textContent = 'Copied';
    } catch {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(document.getElementById('HawthornWelcomeCode'));
      selection.removeAllRanges();
      selection.addRange(range);
      button.textContent = 'Select and copy';
    }
  });
});
